import { render } from "./CtaForm.vue?vue&type=template&id=a9c38a02&ts=true"
import script from "./CtaForm.vue?vue&type=script&lang=ts"
export * from "./CtaForm.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__